import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { IMG } from "@/mock";
import { api, apiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState(""); const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false); const [err, setErr] = useState(""); const [done, setDone] = useState(false);
  const field = "bg-[#16181b] border-white/5 h-11 focus-visible:ring-amber-400/60";
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw.length < 6) return setErr("Password must be at least 6 characters");
    if (pw !== pw2) return setErr("Passwords don't match");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); setDone(true); toast.success("Password updated — sign in with your new password"); setTimeout(() => nav("/app"), 1800); }
    catch (ex) { setErr(apiError(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#0b0b0c] flex flex-col items-center py-9 px-4 text-white">
      <img src={IMG.logo} alt="In The Pocket" className="h-32 w-auto fade-up" />
      <div className="w-full max-w-[466px] mt-9 rounded-xl border border-white/10 bg-[#101113] p-6 fade-up" data-testid="reset-card">
        {!token ? <p className="text-sm text-zinc-400">This reset link is missing its token. Please request a new one from the sign-in page.</p> : done ? (
          <div className="flex items-center gap-3 text-emerald-400"><CheckCircle2 className="w-6 h-6" /><span data-testid="reset-success">Your password has been updated.</span></div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div><h2 className="text-2xl font-light">Choose a new password</h2><p className="text-sm text-zinc-500 mt-1">Make it at least 6 characters.</p></div>
            <div className="space-y-2"><Label>New password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className={field} data-testid="reset-password" /></div>
            <div className="space-y-2"><Label>Confirm password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className={field} data-testid="reset-password-confirm" /></div>
            {err && <div data-testid="reset-error" className="text-sm text-red-400 bg-red-400/10 border border-red-400/20 rounded-lg px-3 py-2">{err}</div>}
            <button type="submit" disabled={busy} data-testid="reset-submit" className="w-full h-11 rounded-lg bg-amber-400 hover:bg-amber-300 disabled:opacity-60 text-zinc-900 font-medium flex items-center justify-center gap-2">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Update password</button>
          </form>
        )}
      </div>
      <Link to="/app" className="text-sm text-amber-400 mt-6 hover:text-amber-300">← Back to sign in</Link>
    </div>
  );
}
